import { useFormContext } from '@calendly/form';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { ArrowExpandIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { BodyText } from '@calendly/ui/components/typography';
import { primaryColorL1 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useEventType } from 'features/event_type_provider';
import { MultiHost } from './multi_host';
import { SingleHost } from './single_host';
import { useCalendarSettingsUrl } from '../../hooks';
const connectedCalendarsLinkCss = "c1qfijyk";
const ConnectedCalendarsLink = forwardRef((props, ref) => {
  const href = useCalendarSettingsUrl();
  const target = '_blank';
  const rel = 'noopener noreferrer';
  const underline = false;
  return <Link ref={ref} {...props} href={href} target={target} rel={rel} underline={underline} className={classNames(connectedCalendarsLinkCss, props.className)}>
      {props.children}
      <ArrowExpandIcon inline color={primaryColorL1} spacingLeft="4" />
    </Link>;
});
export const FreeBusyRules = () => {
  const {
    values: {
      doubleBookingRuleMemberships
    }
  } = useFormContext();
  const {
    isUser
  } = useEventType();
  return <>
      <BodyText color="muted">
        {HtmlParser(I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.description'), {
        ConnectedCalendarsLink
      })}
      </BodyText>
      {isUser ? <SingleHost doubleBookingRuleMembership={doubleBookingRuleMemberships[0]} /> : <MultiHost doubleBookingRuleMemberships={doubleBookingRuleMemberships} />}
    </>;
};

require("./free_busy_rules.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./free_busy_rules.js");